var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFavoriteIconOrange(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.0001 28L15.4376 27.625C12.7639 25.8394 9.38075 23.8212 6.87512 20.855C4.2345 17.73 2.96762 14.5206 3.00012 11.0425C3.0395 7.15875 6.15387 4 9.94262 4C12.9495 4 14.9489 5.75 16.0001 7.01312C17.0514 5.75 19.0507 4 22.0576 4C25.8464 4 28.9607 7.15875 29.0001 11.0406C29.0351 14.5206 27.7682 17.7281 25.1251 20.8531C22.6195 23.8212 19.2364 25.8394 16.5626 27.625L16.0001 28Z",
    fill: "#FF955A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFavoriteIconOrange);
export default __webpack_public_path__ + "static/media/favoriteIconOrange.6d2123598495b14bd66270aa6c880614.svg";
export { ForwardRef as ReactComponent };